import { render, staticRenderFns } from "./CoinInfo.vue?vue&type=template&id=0b287fb9"
import script from "./CoinInfo.vue?vue&type=script&lang=js"
export * from "./CoinInfo.vue?vue&type=script&lang=js"
import style0 from "./CoinInfo.vue?vue&type=style&index=0&id=0b287fb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports